// This is just an example,
// so you can safely delete all default props below

export default {
    no_record: 'Det er ingen rekorder.'
}
